import { useCallback, useEffect, useReducer, useState } from 'react'
import Select from 'react-select';
import Switch from '@mui/material/Switch';
import { useDispatch, useSelector } from 'react-redux'
import {
    updateTopHeader,
    updateLoading
} from '../../../redux/features/common/commonSlice'
import ApiCaller from '../../constants/ApiCaller'
import urls from '../../constants/apiurl'
import { showDangerToast, showToast } from '../../constants/toaster'
import NavBar from '../../structure/NavBar'
import { NavBarTop } from '../../structure/NavBarTop'
import { Pagination } from '@mui/material';
import InsufficientPermission from '../../custom/InSufficientPermission';
import Utils from '../../constants/Utils';
import { useNavigate } from 'react-router-dom'
import { s3 } from '../../constants/awsConfig'

// Add custom styles
const customStyles = `
    .plan-section {
        transition: all 0.3s ease;
    }
    
    .plan-section:hover {
        transform: translateY(-2px);
    }
    
    .table-container {
        transition: all 0.3s ease;
    }
    
    .table-container:hover {
        box-shadow: 0 8px 25px rgba(0,0,0,0.08) !important;
    }
    
    .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 60px;
        height: 60px;
        background: rgba(255,255,255,0.2);
        border-radius: 50%;
    }
    
    .input-group-text {
        font-weight: 600;
    }
    
    .btn:hover {
        transform: translateY(-1px);
        transition: all 0.2s ease;
    }
    
    .react-select__control:hover {
        transform: translateY(-1px);
        transition: all 0.2s ease;
    }
    
    .image-preview-container:hover img {
        transform: scale(1.05);
        transition: all 0.2s ease;
    }
    
    .border-bottom {
        border-bottom: 1px solid #e2e8f0 !important;
    }
    
    tr:hover td {
        background: rgba(102, 126, 234, 0.02) !important;
        transition: all 0.2s ease;
    }
    
    .text-purple {
        color: #8b5cf6 !important;
    }
`;

// Inject styles
if (!document.getElementById('service-provider-plans-styles')) {
    const styleSheet = document.createElement('style');
    styleSheet.id = 'service-provider-plans-styles';
    styleSheet.textContent = customStyles;
    document.head.appendChild(styleSheet);
}
const label = { inputProps: { 'aria-label': 'Size switch demo' } }

// Plan types and features
const planTypes = [
    { value: 'BASIC', label: 'Basic' },
    { value: 'BASIC_BOOSTER', label: 'Basic + Booster' },
    { value: 'SUPA_PLUS', label: 'Supa Plus' },
];
const planDurations = [
    { value: 'DAILY', label: 'Daily' },
    { value: 'WEEKLY', label: 'Weekly' },
    { value: 'MONTHLY', label: 'Monthly' },
    { value: 'QUARTERLY', label: 'Quarterly' },
    { value: 'YEARLY', label: 'Yearly' },
];

export const MerchantRiderSubscriptionList = props => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const [show, setShow] = useState(false);
    const [countryCodeList, setCountryCodeList] = useState([]);
    const [errors, setErrors] = useState({});
    const [planConfig, setPlanConfig] = useState(() => {
        const initial = {};
        planTypes.forEach(plan => {
            initial[plan.value] = {};
            planDurations.forEach(d => {
                initial[plan.value][d.value] = {
                    be_on_platform: false,
                    product_reels_toggle: false,
                    product_reels_count: '',
                    boosting_reels_toggle: false,
                    boosting_reels_count: '',
                    one_to_many: false,
                    price: '',
                    image: null,
                    imagePreview: null,
                    applyOn: [],
                };
            });
        });
        return initial;
    });
    const [networkProviderDetails, setNetworkProviderDetails] = useState({})
    const LOADING_ENABLE = useSelector(state => state?.loading)
    const userData = useSelector(state => state?.userData)
    const userPermisiions = useSelector(state => state?.permission)
    let currentModulePermission;
    let viewPermission = true;
    let editPermission = false;
    let deletePermissionVal = false;
    let activePermission = false;
    // Check authentication on mount
    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('userToken');
            const userData = localStorage.getItem('userData');

            if (!token || !userData) {
                navigate('/login');
                return;
            }

            // Update header only if authenticated
            dispatch(updateTopHeader('Network Provider Manager'));
        };
        checkAuth();
    }, []);

    const uploadFileToAWS = async (selectedFile) => {
        if (!selectedFile) return;
        const params = {
            Bucket: 'supa-dev-bucket',
            Key: `uploads/${selectedFile.name}`,
            Body: selectedFile,
            ContentType: selectedFile.type,
        };
        try {
            const data = await s3.upload(params).promise();
            const url = data.Location.replace(
                "https://supa-dev-bucket.s3.af-south-1.amazonaws.com/",
                "https://d2up68x544gew2.cloudfront.net/"
            );
            return { success: true, url };
        } catch (error) {
            console.error('Error uploading file:', error);
            return { success: false };
        }
    };

    const validate = () => {
        const newErrors = {};
        let hasAtLeastOnePackage = false;
        let planErrors = {};
        for (const plan of planTypes) {
            for (const duration of planDurations) {
                const pkg = planConfig[plan.value][duration.value];
                const pkgErrors = {};
                // If any feature is enabled or price is set, validate this package
                const isActive =
                    pkg.be_on_platform ||
                    pkg.product_reels_toggle ||
                    pkg.boosting_reels_toggle ||
                    pkg.one_to_many ||
                    (pkg.price && Number(pkg.price) > 0);
                if (isActive) {
                    hasAtLeastOnePackage = true;
                    // Apply On required
                    if (!pkg.applyOn || pkg.applyOn.length === 0) {
                        pkgErrors.applyOn = 'Select at least one type (merchant/rider)';
                    }
                    // Price required and > 0
                    if (!pkg.price || Number(pkg.price) <= 0) {
                        pkgErrors.price = 'Enter a valid price';
                    }
                    // Product reels count required if toggle is on
                    if (pkg.product_reels_toggle && (!pkg.product_reels_count || Number(pkg.product_reels_count) <= 0)) {
                        pkgErrors.product_reels_count = 'Enter count';
                    }
                    // Boosting reels count required if toggle is on
                    if (pkg.boosting_reels_toggle && (!pkg.boosting_reels_count || Number(pkg.boosting_reels_count) <= 0)) {
                        pkgErrors.boosting_reels_count = 'Enter count';
                    }
                }
                if (Object.keys(pkgErrors).length > 0) {
                    if (!planErrors[plan.value]) planErrors[plan.value] = {};
                    planErrors[plan.value][duration.value] = pkgErrors;
                }
            }
        }
        if (!hasAtLeastOnePackage) {
            newErrors.packages = 'Configure at least one package';
        }
        if (Object.keys(planErrors).length > 0) {
            newErrors.planConfig = planErrors;
        }
        setErrors(newErrors);
        return newErrors;
    };

    const showAllValidationErrors = (errors) => {
        let messages = [];
        if (errors.packages) messages.push(errors.packages);
        if (errors.planConfig) {
            for (const plan in errors.planConfig) {
                for (const duration in errors.planConfig[plan]) {
                    const pkgErr = errors.planConfig[plan][duration];
                    for (const key in pkgErr) {
                        messages.push(`${planTypes.find(p => p.value === plan).label} - ${planDurations.find(d => d.value === duration).label}: ${pkgErr[key]}`);
                    }
                }
            }
        }
        if (messages.length > 0) showDangerToast(messages.join('\n'));
    };

    const handleGroupedPlanChange = (plan, duration, feature, value) => {
        setPlanConfig(prev => ({
            ...prev,
            [plan]: {
                ...prev[plan],
                [duration]: {
                    ...prev[plan][duration],
                    [feature]: value,
                    ...(feature === 'product_reels_toggle' && !value ? { product_reels_count: '' } : {}),
                    ...(feature === 'boosting_reels_toggle' && !value ? { boosting_reels_count: '' } : {}),
                },
            },
        }));
    };

    const handlePackageImageChange = (plan, duration, file) => {
        const preview = file ? URL.createObjectURL(file) : null;
        setPlanConfig(prev => ({
            ...prev,
            [plan]: {
                ...prev[plan],
                [duration]: {
                    ...prev[plan][duration],
                    image: file,
                    imagePreview: preview,
                },
            },
        }));
    };

    const handleApplyOnChange = (plan, duration, values) => {
        setPlanConfig(prev => ({
            ...prev,
            [plan]: {
                ...prev[plan],
                [duration]: {
                    ...prev[plan][duration],
                    applyOn: values,
                },
            },
        }));
    };

    const handleSubmit = async () => {
        const validationResult = validate();
        if (Object.keys(validationResult).length > 0) {
            showAllValidationErrors(validationResult);
            return;
        }
        dispatch(updateLoading(true));
        // Upload all package images and collect URLs
        const imageUploadPromises = [];
        const imageUrlMap = {};
        for (const plan of planTypes) {
            for (const duration of planDurations) {
                const pkg = planConfig[plan.value][duration.value];
                if (pkg.image && pkg.image instanceof File) {
                    imageUploadPromises.push(
                        uploadFileToAWS(pkg.image).then(res => {
                            if (res.success) {
                                imageUrlMap[`${plan.value}_${duration.value}`] = res.url;
                            }
                        })
                    );
                }
            }
        }
        await Promise.all(imageUploadPromises);
        // Prepare final request body
        const requestBody = [];
        for (const plan of planTypes) {
            for (const duration of planDurations) {
                const pkg = planConfig[plan.value][duration.value];
                requestBody.push({
                    planType: plan.value,
                    duration: duration.value,
                    beOnPlatform: !!pkg.be_on_platform,
                    productReels: pkg.product_reels_toggle ? Number(pkg.product_reels_count) || 0 : 0,
                    boostingReels: pkg.boosting_reels_toggle ? Number(pkg.boosting_reels_count) || 0 : 0,
                    oneToMany: !!pkg.one_to_many,
                    price: Number(pkg.price) || 0,
                    image: imageUrlMap[`${plan.value}_${duration.value}`] || null,
                    applyOn: pkg.applyOn,
                });
            }
        }
        dispatch(updateLoading(false));
        const finalBody = { plans: requestBody };
        console.log("finalBody", finalBody);
        try {
            dispatch(updateLoading(true));
            let path = urls.addUpdateServiceProviderPlans;
            var res = await ApiCaller.post(finalBody, path, userData?.access_token);
            const response = await res.response.json();
            if (response.status === '200' || response.status === 200) {
                dispatch(updateLoading(false));
                showToast(response?.message);
            } else {
                dispatch(updateLoading(false));
                showDangerToast(response.message);
            }
        } catch (error) {
            console.error('Error preparing request body:', error);
            showDangerToast('Failed to prepare request data');
            return;
        }
    };

    useEffect(() => {
        const getPlanDetails = async () => {
            try {
                dispatch(updateLoading(true));
                let path = urls.getServiceProviderPlans;
                let res = await ApiCaller.get({}, path, userData?.access_token);
                const response = await res.response.json();
                // Populate planConfig from server response
                if (response.successful && response.data && Array.isArray(response.data.plans)) {
                    const newConfig = {};
                    planTypes.forEach(plan => {
                        newConfig[plan.value] = {};
                        planDurations.forEach(d => {
                            newConfig[plan.value][d.value] = {
                                be_on_platform: false,
                                product_reels_toggle: false,
                                product_reels_count: '',
                                boosting_reels_toggle: false,
                                boosting_reels_count: '',
                                one_to_many: false,
                                price: '',
                                image: null,
                                imagePreview: null,
                                applyOn: [],
                            };
                        });
                    });
                    response.data.plans.forEach(plan => {
                        if (newConfig[plan.planType] && newConfig[plan.planType][plan.duration]) {
                            newConfig[plan.planType][plan.duration] = {
                                be_on_platform: !!plan.beOnPlatform,
                                product_reels_toggle: plan.productReels > 0,
                                product_reels_count: plan.productReels > 0 ? String(plan.productReels) : '',
                                boosting_reels_toggle: plan.boostingReels > 0,
                                boosting_reels_count: plan.boostingReels > 0 ? String(plan.boostingReels) : '',
                                one_to_many: !!plan.oneToMany,
                                price: plan.price ? String(plan.price) : '',
                                image: plan.image || null,
                                imagePreview: plan.image || null,
                                applyOn: Array.isArray(plan.applyOn) ? plan.applyOn : [],
                            };
                        }
                    });
                    setPlanConfig(newConfig);
                }
                dispatch(updateLoading(false));
            } catch (error) {
                dispatch(updateLoading(false));
                console.error(error);
                showDangerToast(error.message);
            }
        };
        getPlanDetails();
    }, [dispatch, userData]);




    if (userPermisiions?.modules.length > 0) {
        currentModulePermission = userPermisiions.modules.find((element) => {
            if (element.moduleId === '27') {
                return element
            }
        })?.permissions
        viewPermission = currentModulePermission.find((element) => {
            if (element.name === 'VIEW') {
                return element
            }
        }).isEnable
        editPermission = currentModulePermission.find((element) => {
            if (element.name === 'EDIT') {
                return element
            }
        }).isEnable
        deletePermissionVal = currentModulePermission.find((element) => {
            if (element.name === 'DELETE') {
                return element
            }
        }).isEnable
        activePermission = currentModulePermission.find((element) => {
            if (element.name === 'ACTIVE') {
                return element
            }
        }).isEnable
    }

    return (
        <>
            <NavBar />
            <div className='main-content' style={{ background: '#f8fafc', minHeight: '100vh' }}>
                <NavBarTop />
                <div className='header'>
                    <div className='logo'>
                        <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
                    </div>
                </div>
                {viewPermission ? (
                    <>
                        <div className='container-fluid mt--7'>
                            <div className='row'>
                                <div className='col'>
                                    {/* Loading Overlay */}
                                    {LOADING_ENABLE && (
                                        <div className="position-fixed w-100 h-100 d-flex align-items-center justify-content-center" style={{
                                            top: 0,
                                            left: 0,
                                            background: 'rgba(255,255,255,0.9)',
                                            zIndex: 9999,
                                            backdropFilter: 'blur(4px)'
                                        }}>
                                            <div className="d-flex flex-column align-items-center">
                                                <div className="spinner-border text-primary mb-3" role="status" style={{ width: '3rem', height: '3rem' }}>
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                                <h5 className="text-primary font-weight-bold">Processing Service Provider Plans...</h5>
                                                <p className="text-muted">Please wait while we save your configurations</p>
                                            </div>
                                        </div>
                                    )}

                                    <div className='card shadow-lg border-0' style={{ borderRadius: '16px', overflow: 'hidden' }}>
                                        <div className='card-header bg-white border-0 pb-4'>
                                            {/* Breadcrumb */}
                                            <div className="row mb-4">
                                                <div className="col">
                                                    <nav aria-label="breadcrumb">
                                                        <ol className="breadcrumb bg-transparent p-0 mb-0">
                                                            <li className="breadcrumb-item">
                                                                <a href="#" className="text-muted text-decoration-none">
                                                                    <i className="fas fa-home mr-1"></i>Dashboard
                                                                </a>
                                                            </li>
                                                            <li className="breadcrumb-item">
                                                                <a href="#" className="text-muted text-decoration-none">Subscription Management</a>
                                                            </li>
                                                            <li className="breadcrumb-item active text-primary font-weight-bold" aria-current="page">
                                                                Service Provider Plans
                                                            </li>
                                                        </ol>
                                                    </nav>
                                                </div>
                                            </div>

                                            {/* Header Section */}
                                            <div className='row align-items-center'>
                                                <div className='col'>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='icon icon-shape bg-gradient-primary text-white rounded-circle shadow mr-3' style={{
                                                            width: '60px',
                                                            height: '60px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}>
                                                            <i className='fas fa-cogs fa-lg'></i>
                                                        </div>
                                                        <div>
                                                            <h2 className='mb-1 text-dark font-weight-bold'>Service Provider Plans</h2>
                                                            <p className='mb-0 text-muted d-flex align-items-center'>
                                                                <i className="fas fa-info-circle mr-2 text-info"></i>
                                                                Configure subscription plans for merchants and riders across different durations
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-auto'>
                                                    <div className="d-flex align-items-center gap-3">

                                                        {userData.admin || editPermission && (
                                                            <button
                                                                onClick={() => handleSubmit()}
                                                                disabled={LOADING_ENABLE}
                                                                className='btn btn-primary btn-lg shadow-sm position-relative'
                                                                style={{
                                                                    background: '#6366f1',
                                                                    border: 'none',
                                                                    borderRadius: '12px',
                                                                    padding: '14px 32px',
                                                                    fontWeight: '600',
                                                                    fontSize: '14px',
                                                                    transition: 'all 0.3s ease',
                                                                    opacity: LOADING_ENABLE ? 0.7 : 1
                                                                }}
                                                            >
                                                                {LOADING_ENABLE ? (
                                                                    <>
                                                                        <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
                                                                        Saving...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <i className='fas fa-save mr-2'></i>
                                                                        Save Changes
                                                                    </>
                                                                )}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body px-4 py-0">
                                            <div className="row">
                                                {planTypes.map((plan, planIndex) => (
                                                    <div key={plan.value} className="col-12 mb-5">
                                                        <div className="plan-section">
                                                            <div className="plan-header mb-4 p-4 rounded-lg" style={{
                                                                background: `${planIndex === 0 ? '#6366f1' : planIndex === 1 ? '#ef4444' : '#06b6d4'}`,
                                                                color: 'white',
                                                                boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
                                                            }}>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="icon-wrapper mr-3">
                                                                        <i className={`fas ${planIndex === 0 ? 'fa-star' : planIndex === 1 ? 'fa-rocket' : 'fa-crown'} fa-2x`}></i>
                                                                    </div>
                                                                    <div>
                                                                        <h3 className="mb-1 font-weight-bold">{plan.label}</h3>
                                                                        <p className="mb-0 opacity-90">Configure features and pricing for {plan.label.toLowerCase()} plan</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="table-container" style={{
                                                                overflowX: 'auto',
                                                                background: '#f8f9fe',
                                                                borderRadius: '12px',
                                                                padding: '20px',
                                                                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)'
                                                            }}>
                                                                <table className="table table-borderless align-middle" style={{
                                                                    minWidth: 1000,
                                                                    background: 'white',
                                                                    borderRadius: '8px',
                                                                    overflow: 'hidden',
                                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                                                                }}>
                                                                    <thead style={{ background: '#6b7280' }}>
                                                                        <tr>
                                                                            <th className="text-white font-weight-bold py-4 px-4" style={{
                                                                                minWidth: 240,
                                                                                fontSize: '15px',
                                                                                borderTopLeftRadius: '8px'
                                                                            }}>
                                                                                <i className="fas fa-list-ul mr-2"></i>
                                                                                Features
                                                                            </th>
                                                                            {planDurations.map((d, index) => (
                                                                                <th key={d.value} className="text-white font-weight-bold text-center py-4 px-3" style={{
                                                                                    fontSize: '15px',
                                                                                    minWidth: '140px',
                                                                                    ...(index === planDurations.length - 1 ? { borderTopRightRadius: '8px' } : {})
                                                                                }}>
                                                                                    <i className={`fas ${d.value === 'DAILY' ? 'fa-calendar-day' :
                                                                                        d.value === 'WEEKLY' ? 'fa-calendar-week' :
                                                                                            d.value === 'MONTHLY' ? 'fa-calendar-alt' :
                                                                                                d.value === 'QUARTERLY' ? 'fa-calendar' : 'fa-calendar-check'} mr-2`}></i>
                                                                                    {d.label}
                                                                                </th>
                                                                            ))}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {/* Be on Platform */}
                                                                        <tr className="border-bottom">
                                                                            <td className="text-start py-4 px-4" style={{
                                                                                fontWeight: '600',
                                                                                color: '#2d3748',
                                                                                background: '#f7fafc'
                                                                            }}>
                                                                                <div className="d-flex align-items-center">
                                                                                    <i className="fas fa-store mr-3 text-primary"></i>
                                                                                    Be on Platform
                                                                                </div>
                                                                            </td>
                                                                            {planDurations.map(d => (
                                                                                <td key={d.value} className="text-center py-4 px-3">
                                                                                    <Switch
                                                                                        checked={!!planConfig[plan.value]?.[d.value]?.be_on_platform}
                                                                                        onChange={e => handleGroupedPlanChange(plan.value, d.value, 'be_on_platform', e.target.checked)}
                                                                                        color="primary"
                                                                                        size="medium"
                                                                                    />
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                        {/* Create Product Specific Reel */}
                                                                        <tr className="border-bottom">
                                                                            <td className="text-start py-4 px-4" style={{
                                                                                fontWeight: '600',
                                                                                color: '#2d3748',
                                                                                background: '#f7fafc'
                                                                            }}>
                                                                                <div className="d-flex align-items-center">
                                                                                    <i className="fas fa-video mr-3 text-success"></i>
                                                                                    Create Product Specific Reel
                                                                                </div>
                                                                            </td>
                                                                            {planDurations.map(d => (
                                                                                <td key={d.value} className="text-center py-4 px-3">
                                                                                    <div className="d-flex flex-column align-items-center gap-2">
                                                                                        <Switch
                                                                                            checked={!!planConfig[plan.value]?.[d.value]?.product_reels_toggle}
                                                                                            onChange={e => handleGroupedPlanChange(plan.value, d.value, 'product_reels_toggle', e.target.checked)}
                                                                                            color="primary"
                                                                                            size="medium"
                                                                                        />
                                                                                        {planConfig[plan.value]?.[d.value]?.product_reels_toggle && (
                                                                                            <input
                                                                                                type="number"
                                                                                                min="0"
                                                                                                value={planConfig[plan.value][d.value].product_reels_count || ''}
                                                                                                onChange={e => handleGroupedPlanChange(plan.value, d.value, 'product_reels_count', e.target.value)}
                                                                                                placeholder="Count"
                                                                                                className="form-control form-control-sm text-center"
                                                                                                style={{
                                                                                                    width: 80,
                                                                                                    borderRadius: 8,
                                                                                                    border: '2px solid #e2e8f0',
                                                                                                    padding: '8px',
                                                                                                    fontSize: 14,
                                                                                                    fontWeight: '500'
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                        {/* Boosting Reels */}
                                                                        <tr className="border-bottom">
                                                                            <td className="text-start py-4 px-4" style={{
                                                                                fontWeight: '600',
                                                                                color: '#2d3748',
                                                                                background: '#f7fafc'
                                                                            }}>
                                                                                <div className="d-flex align-items-center">
                                                                                    <i className="fas fa-rocket mr-3 text-warning"></i>
                                                                                    Boosting Reels
                                                                                </div>
                                                                            </td>
                                                                            {planDurations.map(d => (
                                                                                <td key={d.value} className="text-center py-4 px-3">
                                                                                    <div className="d-flex flex-column align-items-center gap-2">
                                                                                        <Switch
                                                                                            checked={!!planConfig[plan.value]?.[d.value]?.boosting_reels_toggle}
                                                                                            onChange={e => handleGroupedPlanChange(plan.value, d.value, 'boosting_reels_toggle', e.target.checked)}
                                                                                            color="primary"
                                                                                            size="medium"
                                                                                        />
                                                                                        {planConfig[plan.value]?.[d.value]?.boosting_reels_toggle && (
                                                                                            <input
                                                                                                type="number"
                                                                                                min="0"
                                                                                                value={planConfig[plan.value][d.value].boosting_reels_count || ''}
                                                                                                onChange={e => handleGroupedPlanChange(plan.value, d.value, 'boosting_reels_count', e.target.value)}
                                                                                                placeholder="Count"
                                                                                                className="form-control form-control-sm text-center"
                                                                                                style={{
                                                                                                    width: 80,
                                                                                                    borderRadius: 8,
                                                                                                    border: '2px solid #e2e8f0',
                                                                                                    padding: '8px',
                                                                                                    fontSize: 14,
                                                                                                    fontWeight: '500'
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                        {/* One to Many */}
                                                                        <tr className="border-bottom">
                                                                            <td className="text-start py-4 px-4" style={{
                                                                                fontWeight: '600',
                                                                                color: '#2d3748',
                                                                                background: '#f7fafc'
                                                                            }}>
                                                                                <div className="d-flex align-items-center">
                                                                                    <i className="fas fa-users mr-3 text-info"></i>
                                                                                    One to Many
                                                                                </div>
                                                                            </td>
                                                                            {planDurations.map(d => (
                                                                                <td key={d.value} className="text-center py-4 px-3">
                                                                                    <Switch
                                                                                        checked={!!planConfig[plan.value]?.[d.value]?.one_to_many}
                                                                                        onChange={e => handleGroupedPlanChange(plan.value, d.value, 'one_to_many', e.target.checked)}
                                                                                        color="primary"
                                                                                        size="medium"
                                                                                    />
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                        {/* Price */}
                                                                        <tr className="border-bottom">
                                                                            <td className="text-start py-4 px-4" style={{
                                                                                fontWeight: '600',
                                                                                color: '#2d3748',
                                                                                background: '#f7fafc'
                                                                            }}>
                                                                                <div className="d-flex align-items-center">
                                                                                    <i className="fas fa-dollar-sign mr-3 text-success"></i>
                                                                                    Price (USD)
                                                                                </div>
                                                                            </td>
                                                                            {planDurations.map(d => (
                                                                                <td key={d.value} className="text-center py-4 px-3">
                                                                                    <div className="input-group" style={{ width: 120, margin: '0 auto' }}>
                                                                                        <div className="input-group-prepend">
                                                                                            <span className="input-group-text bg-light border-right-0" style={{
                                                                                                borderRadius: '8px 0 0 8px',
                                                                                                border: '2px solid #e2e8f0',
                                                                                                fontSize: '12px'
                                                                                            }}>$</span>
                                                                                        </div>
                                                                                        <input
                                                                                            type="number"
                                                                                            min="0"
                                                                                            step="0.01"
                                                                                            value={planConfig[plan.value]?.[d.value]?.price || ''}
                                                                                            onChange={e => handleGroupedPlanChange(plan.value, d.value, 'price', e.target.value)}
                                                                                            placeholder="0.00"
                                                                                            className="form-control form-control-sm text-center border-left-0"
                                                                                            style={{
                                                                                                borderRadius: '0 8px 8px 0',
                                                                                                border: '2px solid #e2e8f0',
                                                                                                fontSize: 14,
                                                                                                fontWeight: '500'
                                                                                            }}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                        {/* Image upload per package */}
                                                                        <tr className="border-bottom">
                                                                            <td className="text-start py-4 px-4" style={{
                                                                                fontWeight: '600',
                                                                                color: '#2d3748',
                                                                                background: '#f7fafc'
                                                                            }}>
                                                                                <div className="d-flex align-items-center">
                                                                                    <i className="fas fa-image mr-3 text-purple"></i>
                                                                                    Plan Image
                                                                                </div>
                                                                            </td>
                                                                            {planDurations.map(d => (
                                                                                <td key={d.value} className="text-center py-4 px-3">
                                                                                    <div className="d-flex flex-column align-items-center gap-2">
                                                                                        <label className="btn btn-outline-primary btn-sm mb-0" style={{
                                                                                            cursor: 'pointer',
                                                                                            borderRadius: '8px',
                                                                                            padding: '8px 16px',
                                                                                            fontSize: '12px',
                                                                                            fontWeight: '500'
                                                                                        }}>
                                                                                            <input
                                                                                                type="file"
                                                                                                accept="image/*"
                                                                                                style={{ display: 'none' }}
                                                                                                onChange={e => handlePackageImageChange(plan.value, d.value, e.target.files[0])}
                                                                                            />
                                                                                            <i className="fas fa-upload mr-1"></i>
                                                                                            Upload
                                                                                        </label>
                                                                                        {planConfig[plan.value][d.value].imagePreview && (
                                                                                            <div className="image-preview-container">
                                                                                                <img
                                                                                                    src={planConfig[plan.value][d.value].imagePreview}
                                                                                                    alt="preview"
                                                                                                    style={{
                                                                                                        width: 50,
                                                                                                        height: 50,
                                                                                                        borderRadius: 8,
                                                                                                        border: '2px solid #e2e8f0',
                                                                                                        objectFit: 'cover',
                                                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                        {/* Apply On */}
                                                                        <tr>
                                                                            <td className="text-start py-4 px-4" style={{
                                                                                fontWeight: '600',
                                                                                color: '#2d3748',
                                                                                background: '#f7fafc'
                                                                            }}>
                                                                                <div className="d-flex align-items-center">
                                                                                    <i className="fas fa-tag mr-3 text-danger"></i>
                                                                                    Apply On
                                                                                </div>
                                                                            </td>
                                                                            {planDurations.map(d => (
                                                                                <td key={d.value} className="text-center py-4 px-3">
                                                                                    <Select
                                                                                        isMulti
                                                                                        options={[
                                                                                            { value: 'merchant', label: 'Merchant' },
                                                                                            { value: 'rider', label: 'Rider' },
                                                                                        ]}
                                                                                        value={planConfig[plan.value][d.value].applyOn.map(v => ({ value: v, label: v.charAt(0).toUpperCase() + v.slice(1) }))}
                                                                                        onChange={selected => handleApplyOnChange(plan.value, d.value, selected.map(opt => opt.value))}
                                                                                        placeholder="Select..."
                                                                                        styles={{
                                                                                            control: base => ({
                                                                                                ...base,
                                                                                                minHeight: 38,
                                                                                                fontSize: 13,
                                                                                                borderRadius: 8,
                                                                                                border: '2px solid #e2e8f0',
                                                                                                boxShadow: 'none',
                                                                                                '&:hover': {
                                                                                                    border: '2px solid #cbd5e0'
                                                                                                }
                                                                                            }),
                                                                                            multiValue: base => ({
                                                                                                ...base,
                                                                                                background: '#6366f1',
                                                                                                color: 'white',
                                                                                                borderRadius: 4
                                                                                            }),
                                                                                            multiValueLabel: base => ({
                                                                                                ...base,
                                                                                                color: 'white',
                                                                                                fontWeight: '500'
                                                                                            }),
                                                                                            multiValueRemove: base => ({
                                                                                                ...base,
                                                                                                color: 'white',
                                                                                                '&:hover': {
                                                                                                    backgroundColor: 'rgba(255,255,255,0.3)',
                                                                                                    color: 'white'
                                                                                                }
                                                                                            }),
                                                                                            valueContainer: base => ({ ...base, padding: '2px 8px' }),
                                                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                        }}
                                                                                        menuPlacement="auto"
                                                                                        menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                                                        classNamePrefix="react-select"
                                                                                    />
                                                                                </td>
                                                                            ))}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <InsufficientPermission />
                )}
            </div>
        </>
    )
}
